import navigation from "@/lang/ar/navigation";
import generics from "@/lang/ar/generics";
import questions from "@/lang/ar/questions";
import a11y from "@/lang/ar/a11y";
import velt from "@/lang/ar/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
